(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-form"] && !Shopify.designMode) return;
  try {
    
  /* Shadow-DOM attempt: if the Shopify Forms app isolates its fields in an
     OPEN shadow root, theme CSS can't reach them — so we inject a <style>
     directly into each shadow root. (Does nothing if the root is closed.) */
  (function () {
    var CSS =
      'input[class*="_formInputField_"],' +
      'textarea[class*="_formInputField_"],' +
      'select[class*="_formInputField_"]' +
      '{background:#fff!important;background-color:#fff!important;}';

    function injectInto(root) {
      if (!root || root.__appFormStyled) return;
      var s = document.createElement('style');
      s.textContent = CSS;
      root.appendChild(s);
      root.__appFormStyled = true;
    }

    function scan(node) {
      if (!node) return;
      if (node.shadowRoot) injectInto(node.shadowRoot);
      var kids = node.children || [];
      for (var i = 0; i < kids.length; i++) scan(kids[i]);
    }

    function run() {
      document.querySelectorAll('[data-app-form]').forEach(scan);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    // The form can render asynchronously after page load.
    var tries = 0;
    var timer = setInterval(function () {
      run();
      if (++tries > 20) clearInterval(timer);
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Populate every [data-wp-service-links] element (footer Services column)
     with the live service CATEGORIES from the WordPress taxonomy API. */
  (function () {
    var URL = 'https://versaillesmedicalspa.com/wp-json/wp/v2/service-category?per_page=100&_fields=id,name,link,count';

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function strip(h) { var d = document.createElement('div'); d.innerHTML = h == null ? '' : String(h); return (d.textContent || '').replace(/\s+/g, ' ').trim(); }

    function run() {
      var containers = document.querySelectorAll('[data-wp-service-links]');
      if (!containers.length) return;

      fetch(URL, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (items) {
          if (!Array.isArray(items) || !items.length) return;
          var terms = items.filter(function (s) { return s.count !== 0; });
          if (!terms.length) terms = items;
          containers.forEach(function (ul) {
            var limit = parseInt(ul.getAttribute('data-limit'), 10);
            var list = (limit && limit > 0) ? terms.slice(0, limit) : terms;
            var linkClass = ul.getAttribute('data-link-class') || '';
            ul.innerHTML = list.map(function (s) {
              return '<li><a href="' + esc(s.link || '#') + '" class="' + linkClass + '">' +
                esc(strip(s.name)) + '</a></li>';
            }).join('');
          });
        })
        .catch(function (e) { console.error('[wp-service-links]', e); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initMegaMenus() {
    document.querySelectorAll('[data-mega]').forEach(function (item) {
      if (item.__megaInit) return;
      item.__megaInit = true;

      var panel = item.querySelector('[data-mega-panel]');
      var hideTimer;

      function open() {
        clearTimeout(hideTimer);
        item.classList.add('mega-open');
      }
      function scheduleClose() {
        hideTimer = setTimeout(function () {
          item.classList.remove('mega-open');
        }, 220);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      if (panel) {
        panel.addEventListener('mouseenter', open);
        panel.addEventListener('mouseleave', scheduleClose);
      }
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
    });
  }

  function initMegaOfferImage() {
    document.querySelectorAll('[data-mega-image-wrap][data-offer-url]').forEach(function (wrap) {
      if (wrap.__offerInit) return;
      wrap.__offerInit = true;
      var url = wrap.getAttribute('data-offer-url');
      if (!url) return;
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          if (d && d.banner_url) { wrap.setAttribute('href', d.banner_url); }
          var src = d && (d.offer_banner || d.offer_banner_mobile);
          if (!src) return;
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.className = 'block h-auto w-full';
          wrap.innerHTML = '';
          wrap.appendChild(img);
        })
        .catch(function () {});
    });
  }

  // Populate the mega menu's service links from the WordPress services API.
  function initMegaServices() {
    document.querySelectorAll('[data-mega-services][data-services-url]').forEach(function (ul) {
      if (ul.__svcInit) return;
      ul.__svcInit = true;
      var url = ul.getAttribute('data-services-url');
      if (!url) return;
      var limit = parseInt(ul.getAttribute('data-limit'), 10) || 0;
      var linkClass = ul.getAttribute('data-link-class') || '';

      function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s == null ? '' : String(s); return t.value; }
      function escHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
      function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (list) {
          if (!Array.isArray(list) || !list.length) return;
          if (limit > 0) list = list.slice(0, limit);
          var html = list.map(function (s) {
            if (s.count === 0) return '';
            var raw = (s.name != null) ? s.name : (s.title && (s.title.rendered != null ? s.title.rendered : s.title));
            var name = decode(raw);
            var href = s.link || '#';
            if (!name) return '';
            return '<li><a href="' + escAttr(href) + '" class="' + linkClass + '">' + escHtml(name) + '</a></li>';
          }).join('');
          if (html) ul.innerHTML = html;
        })
        .catch(function () {});
    });
  }

  function initHeader() { initMegaMenus(); initMegaOfferImage(); initMegaServices(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
  document.addEventListener('shopify:section:load', initHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // Build a GET URL from a form, dropping empty values.
    function formUrl(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (v !== '' && v != null) params.append(k, v);
      });
      var qs = params.toString();
      var action = form.getAttribute('action') || location.pathname;
      return action + (qs ? '?' + qs : '');
    }

    // Fetch a collection URL and swap only the [data-collection] region in place.
    function load(url, push) {
      var col = document.querySelector('[data-collection]');
      if (!col) { window.location.href = url; return; }
      col.classList.add('is-loading');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-collection]');
          if (next) {
            col.innerHTML = next.innerHTML;
          } else {
            window.location.href = url; return;
          }
          if (push !== false) history.pushState({ vmsCollection: 1 }, '', url);
          col.classList.remove('is-loading');
          var top = col.getBoundingClientRect().top + window.pageYOffset - 110;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(function () {
          col.classList.remove('is-loading');
          window.location.href = url;
        });
    }

    function init() {
      var col = document.querySelector('[data-collection]');
      if (!col || col.__ajaxInit) return;
      col.__ajaxInit = true;

      // Filter checkbox/radio change + sort dropdown change → load
      col.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.closest('[data-filters-form]') && (t.type === 'checkbox' || t.type === 'radio')) {
          var ff = t.closest('form'); if (ff) load(formUrl(ff));
        } else if (t.matches('[data-auto-submit]') && t.form) {
          load(formUrl(t.form));
        }
      });

      // Price "Apply" (filters form submit) → load
      col.addEventListener('submit', function (e) {
        var form = e.target;
        if (form && form.matches('[data-filters-form]')) {
          e.preventDefault();
          load(formUrl(form));
        }
      });

      // Same-collection links (pagination, "Clear all") → load; product links navigate normally
      col.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        var a = e.target.closest('a');
        if (!a || !a.href || a.target === '_blank') return;
        var u;
        try { u = new URL(a.href); } catch (_) { return; }
        if (u.origin === location.origin && u.pathname === location.pathname) {
          e.preventDefault();
          load(a.href);
        }
      });
    }

    window.addEventListener('popstate', function () {
      if (document.querySelector('[data-collection]')) load(location.href, false);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants]') ? root.querySelector('[data-variants]').textContent : '[]');
    var select = root.querySelector('[data-variant-select]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    var mainImage = root.querySelector('[data-main-image]');
    var optionInputs = root.querySelectorAll('input[name^="option-"]');

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('input[name^="option-"]:checked').forEach(function (i) {
        opts[parseInt(i.dataset.optionIndex, 10)] = i.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var variant = optionInputs.length ? findVariant(currentOptions()) : variants[0];
      if (!variant) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Unavailable'; return; }
      if (select) select.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePriceEl.textContent = sale ? money(variant.compare_at_price) : '';
        comparePriceEl.classList.toggle('hidden', !sale);
        if (saveEl) { saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price); saveEl.classList.toggle('hidden', !sale); }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (mainImage && variant.featured_image) mainImage.src = variant.featured_image.src;
    }

    optionInputs.forEach(function (i) { i.addEventListener('change', update); });

    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImage) mainImage.src = btn.dataset.thumb;
        thumbs.forEach(function (t) { t.classList.add('ring-transparent'); t.classList.remove('ring-brand-accent'); });
        btn.classList.remove('ring-transparent');
        btn.classList.add('ring-brand-accent');
      });
    });

    var qty = root.querySelector('[data-qty]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = parseInt(qty.value || '1', 10) + 1; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-products"] && !Shopify.designMode) return;
  try {
    
  function initProductFilters() {
    document.querySelectorAll('[data-products-section]').forEach(function (sec) {
      if (sec.__pfInit) return;
      sec.__pfInit = true;
      var filters = sec.querySelector('[data-product-filters]');
      if (!filters) return;
      var cards = sec.querySelectorAll('[data-product-card]');

      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-filter]');
        if (!btn) return;
        var f = btn.getAttribute('data-filter');

        filters.querySelectorAll('[data-filter]').forEach(function (b) {
          b.classList.remove('bg-navy', 'text-white');
          b.classList.add('text-primary/60');
        });
        btn.classList.add('bg-navy', 'text-white');
        btn.classList.remove('text-primary/60');

        cards.forEach(function (c) {
          var t = c.getAttribute('data-type') || '';
          if (f === '*' || t === f) {
            c.classList.remove('is-hidden');
          } else {
            c.classList.add('is-hidden');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFilters);
  } else {
    initProductFilters();
  }
  document.addEventListener('shopify:section:load', initProductFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-services-slider]').forEach(function (root) {
    var url = root.getAttribute('data-url');
    var words = parseInt(root.getAttribute('data-words'), 10) || 14;
    var bookUrl = root.getAttribute('data-book-url') || '#';
    var bookLabel = root.getAttribute('data-book-label') || 'Book Now';
    var learnLabel = root.getAttribute('data-learn-label') || 'Learn More';
    var wrapper = root.querySelector('[data-wrapper]');
    var swiperEl = root.querySelector('.swiper');
    var errorEl = root.querySelector('[data-error]');

    if (!url || !wrapper) return;

    function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function stripTags(h) { var d = document.createElement('div'); d.innerHTML = h == null ? '' : String(h); return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
    function truncate(t, n) { var p = t.split(' '); return p.length <= n ? t : p.slice(0, n).join(' ') + '…'; }
    function getJSON(u) {
      return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    function whenSwiperReady(cb) {
      if (typeof Swiper !== 'undefined') { cb(); return; }
      var n = 0, t = setInterval(function () { if (typeof Swiper !== 'undefined' || ++n > 40) { clearInterval(t); if (typeof Swiper !== 'undefined') cb(); } }, 50);
    }

    function buildCards(items, mediaMap) {
      wrapper.innerHTML = items.map(function (s) {
        var title = escapeHtml(stripTags(s.title && s.title.rendered));
        var desc = escapeHtml(truncate(stripTags(s.excerpt && s.excerpt.rendered), words));
        var link = escapeHtml(s.link || '#');
        var src = s.featured_image_url || mediaMap[s.featured_media] || '';
        var media = src
          ? '<img src="' + escapeHtml(src) + '" alt="' + title + '" loading="lazy" class="h-full w-full object-cover">'
          : '<div class="flex h-full w-full items-center justify-center text-brand/30"><svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="12" cy="12" r="9"/></svg></div>';

        return '' +
          '<div class="swiper-slide">' +
            '<div class="flex h-full flex-col rounded-3xl border border-[#00000010] bg-white p-3">' +
              '<div class="aspect-[4/3] overflow-hidden rounded-2xl bg-cream-soft">' + media + '</div>' +
              '<div class="flex flex-1 flex-col px-2 pb-1 pt-4">' +
                '<h3 class="font-serif text-lg leading-tight text-primary">' + title + '</h3>' +
                (desc ? '<p class="mt-2 line-clamp-2 text-sm leading-relaxed text-brand">' + desc + '</p>' : '') +
                '<div class="mt-4 flex flex-wrap items-center gap-2">' +
                  '<a href="' + escapeHtml(bookUrl) + '" class="rounded-full bg-navy px-5 py-2.5 text-sm font-medium text-white transition-opacity hover:opacity-90">' + escapeHtml(bookLabel) + '</a>' +
                  '<a href="' + link + '" class="rounded-full border border-[#00000020] bg-cream px-5 py-2.5 text-sm font-medium text-primary transition-colors hover:border-brand-accent">' + escapeHtml(learnLabel) + '</a>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      whenSwiperReady(function () {
        new Swiper(swiperEl, {
          slidesPerView: 1.15,
          slidesPerGroup: 1,
          spaceBetween: 20,
          breakpoints: {
            640: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 24 },
            1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 }
          },
          navigation: {
            prevEl: root.querySelector('.services-cards-prev'),
            nextEl: root.querySelector('.services-cards-next')
          },
          pagination: {
            el: root.querySelector('.services-cards-pagination'),
            clickable: true
          }
        });
      });
    }

    getJSON(url)
      .then(function (items) {
        if (!Array.isArray(items) || items.length === 0) {
          wrapper.innerHTML = '';
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'No services found.'; }
          return;
        }

        // Collect featured image IDs and batch-fetch their URLs from the media endpoint
        var ids = [];
        items.forEach(function (s) {
          if (!s.featured_image_url && s.featured_media && ids.indexOf(s.featured_media) === -1) ids.push(s.featured_media);
        });

        if (ids.length === 0) { buildCards(items, {}); return; }

        var mediaUrl = url.split('?')[0].replace(/\/[^/]+$/, '/media') +
          '?per_page=100&_fields=id,source_url&include=' + ids.join(',');

        getJSON(mediaUrl)
          .then(function (media) {
            var map = {};
            (media || []).forEach(function (m) { map[m.id] = m.source_url; });
            buildCards(items, map);
          })
          .catch(function () { buildCards(items, {}); });
      })
      .catch(function (err) {
        wrapper.innerHTML = '';
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Could not load services. Please try again later.'; }
        console.error('[services-slider]', err);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-special-offer]').forEach(function (root) {
    if (root.__offerInit) return;
    root.__offerInit = true;

    var wpUrl = root.getAttribute('data-wp-url');
    var bannerEl = root.querySelector('[data-offer-banner]');
    var titleEl = root.querySelector('[data-offer-title]');
    var contentEl = root.querySelector('[data-offer-content]');
    var errorEl = root.querySelector('[data-offer-error]');

    var modal = root.querySelector('[data-offer-modal]');
    var modalImage = root.querySelector('[data-offer-modal-image]');
    var modalTitle = root.querySelector('[data-offer-modal-title]');
    var ctaEl = root.querySelector('[data-offer-cta]');

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

    function openModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('offer-modal-open');
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('offer-modal-open');
    }

    if (ctaEl) ctaEl.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    root.querySelectorAll('[data-offer-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    function setBanner(desktop, mobile) {
      var html = '';
      if (desktop) { html += '<img src="' + esc(desktop) + '" alt="" class="block w-6xl rounded-3xl">'; }
      /*if (mobile) { html += '<img src="' + esc(mobile) + '" alt="" class="mx-auto mt-6 block w-full max-w-md rounded-2xl">'; }*/
      if (!html) {
        html = '<div class="flex aspect-[21/9] w-full items-center justify-center rounded-3xl bg-cream-soft text-brand/30"><svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="12" cy="12" r="9"/></svg></div>';
      }
      bannerEl.innerHTML = html;
    }

    if (!wpUrl) {
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Set the offer API URL in the section settings.'; }
      return;
    }

    fetch(wpUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data) { throw new Error('Empty response'); }

        titleEl.textContent = (data.offer_name || '');
        contentEl.innerHTML = (data.offer_content || '');
        setBanner(data.offer_banner, data.offer_banner_mobile);

        // Popup: offer image on the left + offer name as the heading
        if (modalTitle) modalTitle.textContent = (data.offer_name || '');
        if (modalImage) {
          var src = data.offer_banner_mobile || data.offer_banner || '';
          modalImage.innerHTML = src ? '<img src="' + esc(src) + '" alt="' + esc(data.offer_name || '') + '">' : '';
        }
      })
      .catch(function (err) {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Could not load the offer. Please try again later.'; }
        contentEl.innerHTML = '';
        setBanner('', '');
        console.error('[special-offer]', err);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonials]').forEach(function (root) {
    var swiperEl = root.querySelector('.swiper');
    if (!swiperEl) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var loop = root.getAttribute('data-loop') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function init() {
      if (typeof Swiper === 'undefined') return;
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 600,
        loop: loop,
        autoplay: autoplay ? { delay: interval, disableOnInteraction: false } : false,
        navigation: {
          prevEl: root.querySelector('.testi-prev'),
          nextEl: root.querySelector('.testi-next')
        },
        pagination: {
          el: root.querySelector('.testimonials-pagination'),
          clickable: true
        }
      });
    }

    function whenReady() {
      if (typeof Swiper !== 'undefined') { init(); return; }
      var n = 0, t = setInterval(function () { if (typeof Swiper !== 'undefined' || ++n > 40) { clearInterval(t); if (typeof Swiper !== 'undefined') init(); } }, 50);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', whenReady);
    else whenReady();
    document.addEventListener('shopify:section:load', whenReady);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-services"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wp-services]').forEach(function (root) {
    var servicesUrl = root.getAttribute('data-services-url');
    var tagsUrl = root.getAttribute('data-tags-url');
    var words = parseInt(root.getAttribute('data-words'), 10) || 20;
    var list = root.querySelector('[data-wp-list]');
    var errorEl = root.querySelector('[data-wp-error]');

    if (!servicesUrl || !tagsUrl) {
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Missing API URL.'; }
      if (list) { list.innerHTML = ''; }
      return;
    }

    function escapeHtml(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML;
    }
    function stripTags(html) {
      var d = document.createElement('div');
      d.innerHTML = html == null ? '' : String(html);
      return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }
    function truncate(text, n) {
      var parts = text.split(' ');
      if (parts.length <= n) return text;
      return parts.slice(0, n).join(' ') + '…';
    }

    function getJSON(url) {
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('Request failed: ' + r.status);
        return r.json();
      });
    }

    Promise.all([getJSON(tagsUrl), getJSON(servicesUrl)])
      .then(function (results) {
        var tags = results[0];
        var services = results[1];

        // Build a bucket per tag id
        var byTag = {};
        var order = [];
        (tags || []).forEach(function (t) {
          byTag[t.id] = { name: t.name, items: [] };
          order.push(t.id);
        });

        (services || []).forEach(function (s) {
          var item = {
            title: stripTags(s.title && s.title.rendered),
            url: s.link || '#',
            desc: truncate(stripTags(s.excerpt && s.excerpt.rendered), words)
          };
          var tagIds = s['service-tag'] || [];
          tagIds.forEach(function (tid) {
            if (byTag[tid]) byTag[tid].items.push(item);
          });
        });

        var cats = order
          .map(function (id) { return byTag[id]; })
          .filter(function (c) { return c.items.length > 0; });

        if (cats.length === 0) {
          list.innerHTML = '';
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'No services found.'; }
          return;
        }

        list.innerHTML = cats.map(function (cat, idx) {
          var open = idx === 0 ? ' open' : '';
          var items = cat.items.map(function (it) {
            return '' +
              '<li class="border-t border-[#00000010] pt-4">' +
                '<a href="' + escapeHtml(it.url) + '" class="font-serif text-lg text-primary transition-colors hover:text-brand-accent">' + escapeHtml(it.title) + '</a>' +
                (it.desc ? '<p class="mt-1 text-sm leading-relaxed text-brand">' + escapeHtml(it.desc) + '</p>' : '') +
              '</li>';
          }).join('');

          return '' +
            '<details class="group rounded-3xl border border-[#00000010] transition-shadow duration-150 open:shadow-[0_4px_24px_rgba(23,31,52,0.06)] hover:shadow-[0_4px_24px_rgba(23,31,52,0.06)]"' + open + '>' +
              '<summary class="flex cursor-pointer list-none items-center justify-between gap-4 p-5 md:p-8 [&::-webkit-details-marker]:hidden">' +
                '<span class="font-serif text-xl leading-tight text-primary md:text-[28px]">' + escapeHtml(cat.name) +
                  ' <span class="align-middle text-sm font-normal text-brand">(' + cat.items.length + ')</span>' +
                '</span>' +
                '<span class="flex h-6 w-6 shrink-0 items-center justify-center text-primary transition-transform duration-150 group-open:rotate-45">' +
                  '<svg class="h-full w-full" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>' +
                '</span>' +
              '</summary>' +
              '<div class="px-5 pb-6 md:px-8 md:pb-8">' +
                '<ul class="grid gap-4 sm:grid-cols-2">' + items + '</ul>' +
              '</div>' +
            '</details>';
        }).join('');
      })
      .catch(function (err) {
        if (list) { list.innerHTML = ''; }
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Could not load services. Please try again later.'; }
        console.error('[wp-services]', err);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
